/** Nyilvános autó URL — szép slug, UUID fallback. */

export function carSlug(car) {
  if (!car) return "";
  return car.slug || car.id || "";
}

export function carPath(car) {
  const slug = carSlug(car);
  return slug ? `/auto/${slug}` : "/";
}

export function carAbsoluteUrl(car) {
  if (typeof window === "undefined") return carPath(car);
  return `${window.location.origin}${carPath(car)}`;
}
